<template>
    <layout-portal>
		<div class="help-page mb-4 mx-auto">
	    	<h1 class="text-center mb-4">Help</h1>	      	
		</div>
    </layout-portal>
</template>

<script>
    import mixin from '../mixin'
    
    export default {
    	 mixins: [mixin],
    	data() {
            return {}
        }
    }

</script>